import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { OptionalTooltip } from "@redotech/redo-web/tooltip/optional-tooltip";
import { InputProvider, input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const creditCardFeeSettingsForm = input<boolean>();

export type CreditCardFeeSettingsValue = InputProvider.Value<
  typeof creditCardFeeSettingsForm
>;

export const creditCardFeeSettingsDefault: CreditCardFeeSettingsValue = true;

export const CreditCardFeeSettingsCard = memo(
  function CreditCardFeeSettingsCard({
    input,
    canTurnOffCreditCardFee,
  }: {
    input: OutboundLabelForm;
    canTurnOffCreditCardFee: boolean;
  }) {
    const chargeCreditCardProcessingFee =
      input.inputs.chargeCreditCardProcessingFee;

    // Suz wants anybody to be able to turn the fee ON, but only certain users can turn it OFF
    const isDisabled =
      chargeCreditCardProcessingFee.value && !canTurnOffCreditCardFee;

    return (
      <Card title="Credit Card Processing Fee">
        <Flex dir="column" gap="md">
          <OptionalTooltip
            meetsCondition={isDisabled}
            tooltipProps={{
              title:
                "This setting is currently enabled. Only certain users can turn this setting off.",
            }}
          >
            <RedoToggle
              disabled={isDisabled}
              label="Charge 3% credit card processing fee"
              setValue={chargeCreditCardProcessingFee.setValue}
              size="sm"
              value={chargeCreditCardProcessingFee.value}
            />
          </OptionalTooltip>
          <Text fontSize="sm" textColor="secondary">
            When enabled, merchants will be charged a 3% fee when adding funds
            to their OMS balance using a credit card. For example, if they
            deposit $100, their card will be charged $103, and $100 will be
            added to their balance.
          </Text>
        </Flex>
      </Card>
    );
  },
);
